import { render, staticRenderFns } from "./studentsByOccurrence.vue?vue&type=template&id=759f6fbb&scoped=true&"
import script from "./studentsByOccurrence.js?vue&type=script&lang=js&"
export * from "./studentsByOccurrence.js?vue&type=script&lang=js&"
import style0 from "./studentsByOccurrence.scss?vue&type=style&index=0&id=759f6fbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f6fbb",
  null
  
)

export default component.exports